const languages = {
    "ar":"العربية",
    "bg": "Български",
    "cs":"Čeština",
    "da":"Dansk",
    "de":"Deutsch",
    "en":"English",
    "es":"Español",
    "et":"Eesti",
    "fa":"فارسی",
    "fr":"Français",
    "hi":"हिन्दी",
    "he":"עברית",
    "hr":"Hrvatski",
    "it":"Italiano",
    "ko": "한국어",
    "lv":"Latviešu",
    "lt":"Lietuvių",
    "hu":"Magyar",
    "nl":"Nederlands",
    "ja":"日本語",
    "no":"Norsk",
    "pa":"ਪੰਜਾਬੀ",
    "pl":"Polski",
    "pt":"Português",
    "ro":"Română",
    "ru":"Русский",
    "sk":"Slovenčina",
    "sl":"Slovenščina",
    "sr":"Српски / srpski",
    "sv":"Svenska",
    "fi":"Suomi",
    "uk":"Українська",
    "zh":"中文"
};

export default languages;


// WEBPACK FOOTER //
// ./src/languages.js